/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { add as addProduct } from '../../utils/cartUtil';
import Toast from '../Toast/Toast';
import BackInStockButton from './BackInStockButton';
const IconLoading = () => (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.3293 3.30669C9.52815 2.02022 4.59312 4.86946 3.30664 9.67065C2.02017 14.4718 4.86941 19.4069 9.6706 20.6934C14.4718 21.9798 19.4068 19.1306 20.6933 14.3294L22.6252 14.847C21.0528 20.7152 15.0211 24.1976 9.15297 22.6252C3.28484 21.0528 -0.197568 15.0211 1.37479 9.15302C2.94715 3.28489 8.97886 -0.197518 14.847 1.37484L14.3293 3.30669Z", fill: "#373737" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.6934 14.3293C21.9798 9.52812 19.1306 4.59308 14.3294 3.30661L14.847 1.37476C20.7152 2.94712 24.1976 8.97882 22.6252 14.8469L20.6934 14.3293Z", fill: "#F2F2F2" }),
        React.createElement("animateTransform", { accumulate: "none", additive: "replace", attributeName: "transform", attributeType: "XML", calcMode: "linear", dur: "1s", fill: "remove", from: "0 12 12", repeatCount: "indefinite", restart: "always", to: "360 12 12", type: "rotate" }))));
const IconTick = () => (React.createElement("svg", { role: "presentation", width: "19", height: "14", viewBox: "0 0 19 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("title", null, "Tick"),
    React.createElement("path", { d: "M1.54297 7.76267L6.36475 12.5846L17.6411 1.30823", stroke: "black", strokeWidth: "2" })));
const ProductTile = ({ product, settings, strings }) => {
    const [hide, setHide] = useState(false);
    const [outOfStockTag, setOutOfStockTag] = useState(false);
    const [registerInterestTag, setRegisterInterestTag] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [addingState, setAddingState] = useState('Add to cart');
    useEffect(() => {
        if (product.tags.indexOf('hidden') !== -1) {
            setHide(true);
        }
        if (product.tags.indexOf('out-of-stock-hq') !== -1) {
            setOutOfStockTag(true);
        }
        if (product.tags.indexOf('register-interest') !== -1) {
            setRegisterInterestTag(true);
        }
    }, [hide, outOfStockTag, registerInterestTag, product.tags]);
    /*useEffect(() => {
        const booxiTrigger = document.querySelector(`[data-booxi-trigger="${product.id}--book-now-collection"]`);
        setTimeout(() => {
          if (!booxiTrigger) {
            return;
          }
          booxiTrigger.setAttribute('onclick', `booxiController.open('${product.id}--book-now-collection');`);
        }, 1000);
    }, []);*/
    const resetButton = () => {
        setAddingState('');
        setIsAdding(false);
    };
    const addToCart = () => {
        let isBundle = false;
        let bundleItems = [];
        product.tags.map((tag) => {
            if (tag.indexOf('bundle_') !== -1) {
                isBundle = true;
                bundleItems.push(tag.split('_')[1]);
            }
        });
        let productData = [{
                id: product.current_variant.id,
                quantity: 1,
            }];
        if (isBundle) {
            productData = [];
            bundleItems.map((item) => {
                productData.push({
                    id: item,
                    quantity: 1,
                });
            });
        }
        setIsAdding(true);
        setAddingState('product-add--adding');
        addProduct(productData)
            .then((items) => {
            if (Array.isArray(items)) {
                setIsAdding(false);
                setAddingState('product-add--added');
                const titles = items.map((item) => item.product_title).join(', ');
                Toast.show(`<b>${titles}</b> <span>${dataJs.product.addToCartToast}</span>`);
                setTimeout(() => {
                    resetButton();
                }, 2000);
            }
            else {
                Toast.show(items === null || items === void 0 ? void 0 : items.description, 'error');
                resetButton();
            }
        })
            .catch((error) => {
            console.error(error);
            Toast.show(dataJs.product.addToCartFailed, 'error');
            resetButton();
        });
    };
    if (hide || !strings || !settings) {
        return null;
    }
    let isTreatment = product.tags.indexOf('Treatment') > -1;
    let ButtonContent = React.createElement(React.Fragment, null);
    if (isTreatment) {
        if (product.tags.indexOf('contact-flagship') > -1) {
            ButtonContent = (React.createElement("a", { href: product.collection_url, className: "button button--secondary" }, strings.contact));
        }
        else {
            ButtonContent = (React.createElement("a", { href: product.collection_url, className: "button button--secondary" }, strings.book_now));
        }
        /*
        ButtonContent = (
          <button
            type="button"
            data-booxi-trigger={`${product.id}--book-now-collection`}
            data-booxi-service={product.metafields.booxi_treatment_id}
            data-booxi-flow="locations"
            data-booxi-api-key='T18l4am3P7s18XylcL24S7mZEM631c1S'
            className="button"
            onClick={() => {
              BookNow.open({
                apiKey:'T18l4am3P7s18XylcL24S7mZEM631c1S',
                language:'en',
                serviceId: product.metafields.booxi_treatment_id,
                bookingFlow: 'locations',
              })
            }}
          >
            {strings.book_now}
          </button>
        );
        */
    }
    else if (outOfStockTag || product.is_available === false || product.variants.length > 1 || product.has_complimentary_product) {
        ButtonContent = (React.createElement(BackInStockButton, { outOfStockTag: outOfStockTag, registerInterestTag: registerInterestTag, settings: settings, strings: strings, product: product }));
    }
    else if (product.available) {
        ButtonContent = (React.createElement("button", { type: "button", onClick: addToCart, disabled: isAdding, className: `product-add product-add--ready button ${addingState}` },
            React.createElement("div", { className: "product-add__default" },
                React.createElement("span", { className: "product-add__text" }, strings.add_to_cart)),
            React.createElement("div", { className: "product-add__loading" },
                React.createElement(IconLoading, null)),
            React.createElement("div", { className: "product-add__added" },
                React.createElement(IconTick, null),
                React.createElement("span", { className: "product-add__added-text" }, strings.added_to_cart))));
    }
    return (React.createElement("div", { className: `collection__product ${isTreatment ? 'collection__product--treatment' : ''}` },
        React.createElement("a", { href: product.collection_url, className: "collection__product-image lazyload" },
            React.createElement("div", { className: "responsive-image__wrapper" },
                React.createElement("img", { className: "responsive-image__image lazyload", src: product.featured_image.url, alt: product.title })),
            product.metafields.hover_image && (React.createElement("a", { href: product.collection_url, className: "collection__product-image__hover lazyload" },
                React.createElement("div", { className: "responsive-image__wrapper" },
                    React.createElement("img", { className: "responsive-image__image lazyload", src: product.metafields.hover_image, alt: product.title })))),
            (product.metafields.visible_tag) && (React.createElement("div", { className: "collection__product-tag" },
                React.createElement("span", null, product.metafields.visible_tag)))),
        React.createElement("div", { className: "collection__product-details" },
            React.createElement("a", { className: "collection__product-title", href: product.collection_url },
                React.createElement("h4", null, product.title)),
            product.metafields.previously_known_as && React.createElement("p", { className: "collection__product-previously-known-as" }, product.metafields.previously_known_as),
            product.metafields.byline && React.createElement("p", { className: "collection__product-byline" }, product.metafields.byline),
            React.createElement("p", { className: `collection__product-price ${isTreatment ? 'collection__product-price--treatment' : ''}` },
                isTreatment && product.metafields.session_duration ? `${product.metafields.session_duration} | ` : '',
                product.price_varies && product.available_variants > 1 ? 'From ' : '',
                product.formatted_price),
            product.metafields.treatment_description && (React.createElement("div", { className: "collection__product-description" },
                React.createElement("p", { dangerouslySetInnerHTML: { __html: product.metafields.treatment_description } }))),
            ButtonContent,
            React.createElement("div", { className: "collection__product-suited" },
                React.createElement("h4", { className: "collection__product-suited-title" }, "Suited to"),
                React.createElement("span", { className: "collection__product-suited-label" }, product.metafields.suited_to)))));
};
export default ProductTile;
